import React, { useState, useEffect, useContext } from 'react';
import JobAssetService from "../../Controller/JobAssetController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

import { useNavigate, Link, useLocation } from 'react-router-dom';
import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import handleSubmitForCheckbox from "../../Controller/CreateJobAssetController";
import JobService from "../../Controller/JobController";
import HelpSite from "../../../Common/HelpLink";
function AssetJobListPage(JobID) {
    JobID = localStorage.getItem('JobID');
    const navigate = useNavigate();
    const [formList, setForms] = useState([]);
    const { t, i18n } = useTranslation();
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [checkboxState, setCheckboxState] = useState({});
    const [isClosed, SetIsClosed] = useState("0");
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setCheckboxState({ ...checkboxState, [name]: checked });
    };
    const handleSubmitForm = async () => {

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/JobsList?saved=true');
        };

        try {

            const checkedAssetIDs = Object.keys(checkboxState).filter(id => checkboxState[id]);
            const UserID = localStorage.getItem("UserID");
            const payload = {
                JobID: JobID,
                UserID: UserID,
                checkedAssets: checkedAssetIDs, // Only true ones sent
            };

            const message = await handleSubmitForCheckbox(payload, redirectCallback);
            if (message == "Data saved successfully") {
                let JobCostID = localStorage.getItem('JobCostID');
                JobCostID = JobCostID + 1;
                localStorage.setItem('JobCostID', JobCostID);
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
        } catch (error) {
            console.error('Error handling form submission:', error);
            // Handle error (e.g., display an error message)
        }
    };
    const fetchJobDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                SetIsClosed(jobDetail[0].IsCompleted);

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };

    useEffect(() => {
        SetIsClosed(localStorage.getItem("Closed"));

        async function fetchData() {
            try {
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };
                const formData = await JobAssetService.GetAllJobAssets(redirectCallback, JobID); // Pass the language parameter
                setForms(formData);
                const initialState = {};
                formData.forEach(form => {
                    initialState[form.PK_Assets_ID] = form.FK_Asset_ID !== null;
                });
                setCheckboxState(initialState);
            } catch (error) {
                console.error('Error fetching Users:', error);
            }
        }
        fetchData();
    }, [JobID, localStorage.getItem("Closed")]); // Listen to changes in language
    const truncateText = (text, maxLength = 50) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    return (
        <div className="p-2">

            {/* SUCCESS / ERROR */}
            {showSuccessMessage && (
                <div className="alert alert-success text-center small">
                    Data saved successfully
                </div>
            )}

            {showErrorMessage && (
                <div className="alert alert-danger text-center small">
                    Validation error
                </div>
            )}

            {/* HEADER */}
            <div className="mb-2 text-muted small">
                Select Assets for Job
            </div>

            {/* LIST */}
            {formList.length === 0 && (
                <div className="text-center text-muted small p-3">
                    No assets available
                </div>
            )}

            {formList.map(form => (
                <div
                    key={form.PK_Assets_ID}
                    className="list-group-item d-flex justify-content-between align-items-center mb-2 shadow-sm rounded-3"
                    style={{
                        border: "1px solid #eee",
                        padding: "12px"
                    }}
                >

                    {/* LEFT */}
                    <div className="d-flex align-items-center">

                        <input
                            type="checkbox"
                            name={form.PK_Assets_ID}
                            checked={checkboxState[form.PK_Assets_ID] || false}
                            onChange={handleCheckboxChange}
                            style={{
                                transform: "scale(1.2)",
                                marginRight: "12px"
                            }}
                        />

                        <div>
                            <div style={{ fontSize: "14px", fontWeight: 600 }}>
                                {form.vc_AssetName}
                            </div>

                            <div style={{ fontSize: "11px", color: "#777" }}>
                                {form.CompanyNames}
                            </div>
                        </div>

                    </div>

                </div>
            ))}

            {/* SAVE BUTTON (STICKY STYLE FEEL) */}
            {formList.length > 0 && (
                <div className="mt-3">
                    <button
                        onClick={handleSubmitForm}
                        className="btn btn-success btn-sm w-100"
                        disabled={isClosed === '1' || isClosed === 1}
                        style={{
                            borderRadius: "10px",
                            fontWeight: 600,
                            padding: "10px"
                        }}
                    >
                        Save 
                    </button>
                </div>
            )}

        </div>
    );
}

export default AssetJobListPage;